import React, {useEffect} from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { DeviceProvider } from './contexts/DeviceContext';
import { LocationProvider } from './contexts/LocationContext';
import { NotificationProvider } from './contexts/NotificationContext';

import Login from './components/Login';
import Signup from './components/Signup.jsx';
import Dashboard from './components/Dashboard';
import ProtectedRoute from './components/ProtectedRoute';
import UserProfile from './components/UserProfile';
import LocationComponent from './components/LocationComponent';
import InAppNotificationSystem from './components/InAppNotificationSystem'; // Import the new component
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/custom.scss';
import Submissions from "./components/Submissions.jsx";
import Settings from "./components/Settings.jsx";
import {EnvironmentProvider} from "./contexts/EnvironmentContext.jsx";
import Tasks from "@/components/Tasks.jsx";
import TermsOfService from "@/components/TermsOfService.jsx";
import Privacy from "@/components/Privacy.jsx";

function AppRoutes() {
    const { subdomainValidation } = useAuth();
    const { isValid, isValidating, subdomain, error } = subdomainValidation;

    if (isValidating) {
        return (
            <div className="container mt-5 text-center">
                <div className="spinner-border" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
                <p className="mt-2">Validating access...</p>
            </div>
        );
    }

    // Show error for invalid subdomain
    if (!isValid) {
        return (
            <div className="container mt-5">
                <div className="alert alert-danger text-center">
                    <h4>Invalid Group</h4>
                    <p>The group "{subdomain}" is not recognized.</p>
                    {error && (
                        <small className="text-muted">
                            Error: {error}
                        </small>
                    )}
                </div>
            </div>
        );
    }

    return (
        <>
            {/* Add the in-app notification system globally */}
            <InAppNotificationSystem />

            <Routes>
                {/* Public routes */}
                <Route path="/login" element={<Login subdomain={subdomain}/>} />
                <Route path="/signup" element={<Signup subdomain={subdomain}/>} />
                <Route path="/privacy" element={<Privacy />} />
                <Route path="/terms" element={<TermsOfService />} />

                {/* Protected routes */}
                <Route element={<ProtectedRoute />}>
                    <Route path="/dashboard" element={<Dashboard subdomain={subdomain}/>} />
                    <Route path="/dashboard/feed" element={<Dashboard page={'feed'} subdomain={subdomain}/>} />
                    <Route path="/dashboard/calendar" element={<Dashboard page={'calendar'} subdomain={subdomain}/>} />
                    <Route path="/submissions" element={<Submissions subdomain={subdomain}/>} />
                    <Route path="/todos" element={<Tasks subdomain={subdomain}/>} />
                    <Route path="/profile" element={<UserProfile subdomain={subdomain}/>} />
                    <Route path="/settings" element={<Settings subdomain={subdomain}/>} />
                    <Route path="/location" element={<LocationComponent subdomain={subdomain}/>} />
                </Route>

                {/* Redirect to login if no route matches */}
                <Route path="*" element={<Navigate to="/login" replace />} />
            </Routes>
        </>
    );
}

function App() {
    return (
        <Router>
            <DeviceProvider>
                <EnvironmentProvider>
                    <AuthProvider>
                        <LocationProvider>
                            <NotificationProvider>
                                <AppRoutes />
                            </NotificationProvider>
                        </LocationProvider>
                    </AuthProvider>
                </EnvironmentProvider>
            </DeviceProvider>
        </Router>
    );
}

export default App;